import React from 'react';
import { Container, Grid, Segment, Header } from 'semantic-ui-react';
import { useCurrentUser } from '../../_services';
import { Credentials } from '../../_components/users/';
import './customerDetail_styles.css';

export const UserProfile = ({ id = null }) => {
  const { currentUser } = useCurrentUser();

  if (!currentUser) {
    return <div>Loading</div>;
  }

  return (
    <div>
      <Container>
        <Grid centered padded>
          <Grid.Column style={{ maxWidth: 500 }}>
            <div
              style={{
                marginBottom: '0px',
                minHeight: '660px',
                paddingLeft: '0px',
                paddingRight: '0px',
                paddingBottom: '0px'
              }}
            >
              <Segment>
                <Grid columns={1}>
                  <Grid.Row>
                    <Grid.Column textAlign="center">
                      <Header as="h2">PROFILE</Header>
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
              <Segment>
                <Grid columns={1} divided stackable>
                  <Grid.Row>
                    <Grid.Column>
                      <Credentials />
                    </Grid.Column>
                  </Grid.Row>
                </Grid>
              </Segment>
            </div>
          </Grid.Column>
        </Grid>
      </Container>
    </div>
  );
};
